export const TRANSFER_TEMPLATES_CONTAINER_TAG_NAME = 'transfer-templates-container';
